// Plugins
import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);
let mm = gsap.matchMedia();

document.addEventListener("DOMContentLoaded", (e) => {
	gsap.to(".scroll-indicator__progress", {
		height: "100%",
		ease: "none",
		scrollTrigger: {
			trigger: "#processus-ctn",
			scrub: true,
			start: "top 0",
		},
	});
	
	mm.add("(min-width: 800px)", () => {


		let processus_texts = gsap.utils.toArray(".processus__text > *");
		processus_texts.forEach((text) => {
			let animateTexts = gsap.timeline({
				scrollTrigger: {
					trigger: text,
					scrub: true,
					start: "top 50%",
					end: "bottom 50%",
				},
			});

			animateTexts.to(text, {
				color: "#ec6e74",
				ease: "none",
			});
		});

		let processus_pics = gsap.utils.toArray(".processus__pics > *");
		processus_pics.forEach((pic) => {
			let animatePics = gsap.timeline({
				scrollTrigger: {
					trigger: pic.parentNode,
					scrub: true,
					start: "top 50%",
					end: "bottom 50%",
				},
			});

			animatePics.from(pic, {
				yPercent: pic.dataset.gsapY,
				ease: "none",
			});

			animatePics.to(pic, {
				yPercent: pic.dataset.gsapY * -1,
			});
		});
	});
});
